import { SVGProps } from 'react';
const SvgHeadingH5 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21 9h-4l-1.25 5.016a3 3 0 1 1 0 3.968M3 5v7m0 0v7m0-7h8m0-7v7m0 0v7"
    />
  </svg>
);
export default SvgHeadingH5;
